import { soundFileMapper } from '@rsos/constants';

function getAudioElementForTone(toneName: string) {
  const soundObject = soundFileMapper.find(s => s.name === toneName);
  if (!soundObject) {
    // eslint-disable-next-line no-console
    console.error(`Unknown audio file: ${toneName}`);
    return;
  }
  return new Audio(soundObject.path);
}

function playOneTone(name: string, volume: number) {
  const audioElement = getAudioElementForTone(name);

  if (audioElement) {
    const duration = audioElement.duration || 6;
    audioElement.volume = volume;
    audioElement.currentTime = 0; // currentTime is universally accepted across browsers
    audioElement.play().catch(error => {
      // Swallow NotAllowedError: The play method is not allowed by the user
      // agent or the platform in the current context, possibly because the user
      // denied permission.
      if (error?.name !== 'NotAllowedError') {
        // eslint-disable-next-line no-console
        console.error(error, {
          extra: {
            audioSrc: audioElement.src,
            errorMessage: error?.message,
          },
        });
      }
    });
    return duration;
  }
  return 0;
}

export function playTone(name: string, volume: number, repeater?: () => void) {
  const duration = playOneTone(name, volume);

  // Repeat the tone, if repeating is offered and the first play was successful
  if (repeater && duration) {
    setTimeout(repeater, duration * 1000);
  }
}
